<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/quoting/shared/basket-add-to-quote/basket-add-to-quote.component.ts
-->
<ng-template #anchor></ng-template>
